// Common Scripts

$j(function() {
	// Tables

	$j('.wp-block-table').wrap('<div class="table-overflow" />');

	function tableOverflow() {
		$j('.table-overflow').each(function() {
			var table_wrapper_width = $j(this).width(),
				table_width = $j(this).children('table').width();

			if (table_width > table_wrapper_width) {
				$j(this).addClass('has-overflow');
			} else {
				$j(this).removeClass('has-overflow');
			}
		});
	}

	tableOverflow();

	$j(window).resize(function() {
		tableOverflow();
	});

	// Toggles

	$j(document).on('click', '.toggle-container__btn', function(e) {
		e.preventDefault();

		var toggle = $j(this),
			container = toggle.closest('.toggle-container'),
			content = container.find('.toggle-container__content');

		toggle.toggleClass('toggle-container__btn--open');
		content.slideToggle('fast').attr('aria-hidden', content.attr('aria-hidden') == 'false' ? 'true' : 'false');
	});

	$j('.toggle-container__btn').on('mouseup touchend', function() {
		$j(this).blur();
	});
});

// Hubspot Form Safari Fix
window.addEventListener('message', function (event) {
	if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
		var css = 'body { height: 0; }',
			style = document.createElement('style');
		style.type = 'text/css';
		style.appendChild(document.createTextNode(css));
		document.querySelector('.hbspt-form iframe').contentDocument.head.appendChild(style);
	}
});